import {SiteContactConfiguration, SiteContactForm} from '../../../../fields/siteContact/types'
import {parsePhoneNumber} from '../../../../utils/phoneNumberUtils'
import {CreateFormInput} from '../types'

export const buildSiteContactForm = ({
  order
}: CreateFormInput<SiteContactConfiguration>): SiteContactForm => {
  return {
    siteContact: {
      name: order.contactInformation?.siteContactName,
      phoneNumber: order.contactInformation?.siteContactNumber
        ? parsePhoneNumber(order.contactInformation?.siteContactNumber, order.orgUnitCountryId)
        : undefined
    }
  }
}
